import { Box, Flex, FlexProps, Text } from '@chakra-ui/react'
import { DirectoryIcon } from 'src/components/common/Icons/DirectoryIcon'
type Props = {
  title?: string
}
export const SubFormSection: React.FC<Props & FlexProps> = ({
  title,
  children,
  ...flexProps
}) => {
  return (
    <Flex gap="4px" w={flexProps.w || '100%'}>
      <DirectoryIcon w="20px" h="20px" color="gray.800" />
      <Box
        p="20px"
        bgColor="gray.70"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="12px"
        w="100%"
        {...flexProps}
      >
        {title && (
          <Flex align="center" gap="8px" mb="16px">
            <Text
              w="100%"
              lineHeight={1}
              fontWeight={700}
              fontSize="14px"
              color="primary.black"
              pb="12px"
              borderBottom="1px solid"
              borderColor="gray.200"
            >
              {title}
            </Text>
          </Flex>
        )}
        {children}
      </Box>
    </Flex>
  )
}
